import React from 'react';

const ContractIcon = ({ width = '15', height = '20' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bootstrap-file">
        <path
          id="Vector"
          d="M5.27202 4.5C5.12735 4.5 4.98862 4.55926 4.88632 4.66475C4.78403 4.77024 4.72656 4.91332 4.72656
          5.0625C4.72656 5.21168 4.78403 5.35476 4.88632 5.46025C4.98862 5.56574 5.12735 5.625 5.27202
          5.625H11.8175C11.9621 5.625 12.1009 5.56574 12.2032 5.46025C12.3055 5.35476 12.3629 5.21168 12.3629
          5.0625C12.3629 4.91332 12.3055 4.77024 12.2032 4.66475C12.1009 4.55926 11.9621 4.5 11.8175
          4.5H5.27202ZM4.72656 7.3125C4.72656 7.16332 4.78403 7.02024 4.88632 6.91475C4.98862 6.80926 5.12735 6.75
          5.27202 6.75H11.8175C11.9621 6.75 12.1009 6.80926 12.2032 6.91475C12.3055 7.02024 12.3629 7.16332 12.3629
          7.3125C12.3629 7.46168 12.3055 7.60476 12.2032 7.71025C12.1009 7.81574 11.9621 7.875 11.8175
          7.875H5.27202C5.12735 7.875 4.98862 7.81574 4.88632 7.71025C4.78403 7.60476 4.72656 7.46168 4.72656
          7.3125ZM5.27202 9C5.12735 9 4.98862 9.05926 4.88632 9.16475C4.78403 9.27024 4.72656 9.41332 4.72656
          9.5625C4.72656 9.71168 4.78403 9.85476 4.88632 9.96025C4.98862 10.0657 5.12735 10.125 5.27202
          10.125H11.8175C11.9621 10.125 12.1009 10.0657 12.2032 9.96025C12.3055 9.85476 12.3629 9.71168 12.3629
          9.5625C12.3629 9.41332 12.3055 9.27024 12.2032 9.16475C12.1009 9.05926 11.9621 9 11.8175 9H5.27202ZM5.27202
          11.25C5.12735 11.25 4.98862 11.3093 4.88632 11.4148C4.78403 11.5202 4.72656 11.6633 4.72656 11.8125C4.72656
          11.9617 4.78403 12.1048 4.88632 12.2102C4.98862 12.3157 5.12735 12.375 5.27202 12.375H8.54474C8.68941 12.375
          8.82815 12.3157 8.93044 12.2102C9.03273 12.1048 9.0902 11.9617 9.0902 11.8125C9.0902 11.6633 9.03273 11.5202
          8.93044 11.4148C8.82815 11.3093 8.68941 11.25 8.54474 11.25H5.27202Z"
          fill="currentColor"
        />
        <path
          id="Vector_2"
          d="M2 2.25C2 1.65326 2.22987 1.08097 2.63904 0.65901C3.04821 0.237053 3.60316 0 4.18182 0L12.9091 0C13.4877
          0 14.0427 0.237053 14.4519 0.65901C14.861 1.08097 15.0909 1.65326 15.0909 2.25V15.75C15.0909 16.3467 14.861
          16.919 14.4519 17.341C14.0427 17.7629 13.4877 18 12.9091 18H4.18182C3.60316 18 3.04821 17.7629 2.63904
          17.341C2.22987 16.919 2 16.3467 2 15.75V2.25ZM12.9091 1.125H4.18182C3.89249 1.125 3.61501 1.24353 3.41043
          1.4545C3.20584 1.66548 3.09091 1.95163 3.09091 2.25V15.75C3.09091 16.0484 3.20584 16.3345 3.41043
          16.5455C3.61501 16.7565 3.89249 16.875 4.18182 16.875H12.9091C13.1984 16.875 13.4759 16.7565 13.6805
          16.5455C13.8851 16.3345 14 16.0484 14 15.75V2.25C14 1.95163 13.8851 1.66548 13.6805 1.4545C13.4759
          1.24353 13.1984 1.125 12.9091 1.125Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default ContractIcon;
